import { detectFileType } from "./fileTypeDetector";
import logger from "./logger";

/**
 * Resolves file extension from filename or by detecting file type.
 * @param {string} fileName - The file name
 * @param {File|Blob} actualFile - The actual file object for type detection
 * @returns {Promise<string|undefined>} The resolved extension
 */

export const resolveFileExtension = async (fileName, actualFile) => {
    const lastDotIndex = fileName.lastIndexOf('.');
    const extension = lastDotIndex > 0
        ? fileName.substring(lastDotIndex + 1).toLowerCase()
        : await detectFileType(actualFile);

    /* istanbul ignore start */
    const isExtensionlessWithType = lastDotIndex <= 0 && extension;
    if (isExtensionlessWithType) {
        logger.info(`📄 Detected type "${extension}" for extensionless file: ${fileName}`);
    }
    /* istanbul ignore stop */

    return extension;
};